export enum tabs {
  PROFILE = 'dashboard.profileHeader',
  PLATFORMS = 'settings.platforms.title',
  SETTINGS = 'settings.header',
}
